<template>
    <div>
      <h3>{{ company_name }}</h3>
      <p class="eligibility_label">
        Check the eligibility
      </p>
      <Input
        :inputField="inputs.requestedAmount"
        inputName="How much funding do you need?"
        inputType="currency"
        :range="[5000, 500000]"
        :icons="{ left: 'fa-dollar-sign' }"
      />
      <Dropdown
      :inputField="inputs.product"
      :options="productOptions"
      inputName="What product are you interested in?"
    />
      <div class="buttons is-right" @click="handleBlur">
        <a class="button is-link padded-button next-button" @click="next">Submit</a>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import CONSTANTS from "@/tools/translations.js";
  import Input from "@/components/shared/Input";
  import Dropdown from "@/components/shared/Dropdown";
//   import Checkbox from "@/components/shared/Checkbox";
//   import AddressInput from "@/components/shared/AddressInput";
  import ApplyPage from "@/components/shared/ApplyPage";
  import $ from "jquery";
  
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  
  export default {
    name: "RenewalApplyForm",
    components: {
      Input,
      Dropdown
    },
    mixins: [ApplyPage],
    props: {
      amt: String,
      lang: String,
    },
    created: function () {
      console.log('created renewal apply form')
      this.language = "en";
      if (this.$route.params.language) {
        this.language = this.$route.params.language;
      }
      var tags = [];
      var language = this.language;
      $.each(CONSTANTS, function (key, value) {
        var translation = value[language];
        tags[key] = value[language];
      });
  
      this.tags = tags;
      //console.log(tags);
      // this.GET_STARTED_HEADING = CONSTANTS.GET_STARTED_HEADING[Vue.prototype.$language]
    },
    mounted : function(){
      console.log('renewal apply form, mounted:')
      console.log('mounted renewal apply form')
      let stored_company_name = getWithExpiry("company_name");
      if(stored_company_name){
        this.company_name = stored_company_name;
      }
      console.log('stored company name:', stored_company_name);
    },
    data() {
      return {
        obj: "business",
        inputs: {
          requestedAmount: Input.model(),
          utm_device_type: this.getDeviceType(),
          utm_browser: this.getBrowserName(),
          utm_OS: this.getOperatingSystem(),
          product: Input.model()
        },
        productOptions: [
          "Working Capital",
          "Equipment Finance",
        ],
  
        tags: [],
  
        show_address_fields: true,
        selected_address: false,
        company_name : "Tell us about your need",
      };
    },
    methods: {
      handleBlur: function () {
        console.log("focus out");
      },
      // toggleAddressFields: function () {
      //   this.show_address_fields = !this.show_address_fields;
      // },
      getOperatingSystem: function () {
        let userAgent = navigator.userAgent || window.navigator.userAgent;
        let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        let iosPlatforms = ["iPhone", "iPad", "iPod"];
  
        let os = null;
  
        macosPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
  
        iosPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
  
        windowsPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
        if (/Android/.test(userAgent)) {
          os = "Android";
        } else if (!os && /Linux/.test(userAgent)) {
          os = "Linux";
        } else if (!os) {
          os = "Other";
        }
        return os;
      },
      getDeviceType: () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
          return "tablet";
        }
        if (
          /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
          )
        ) {
          return "mobile";
        }
        return "desktop";
      },
      getBrowserName: function () {
        let userAgent = navigator.userAgent;
        let browserName;
  
        if (userAgent.match(/chrome|chromium|crios/i)) {
          browserName = "Chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
          browserName = "Firefox";
        } else if (userAgent.match(/safari/i)) {
          browserName = "Safari";
        } else if (userAgent.match(/opr\//i)) {
          browserName = "Opera";
        } else if (userAgent.match(/edg/i)) {
          browserName = "Edge";
        } else {
          browserName = "Unknown browser";
        }
  
        return browserName;
      },
      getGCLID() {
        // console.log(getWithExpiry("gclid"));
        let gclid = getWithExpiry("gclid");
        if (!gclid) return "";
        return gclid;
      },
      getFBCLID() {
        console.log(getWithExpiry("fbclid"));
        let fbclid = getWithExpiry("fbclid");
        if (!fbclid) return "";
        return fbclid;
      },
      getTTCLID() {
        console.log(getWithExpiry("ttclid"));
        let ttclid = getWithExpiry("ttclid");
        if (!ttclid) return "";
        return ttclid;
      },
      getFBP() {
        console.log(getWithExpiry("_fbp"));
        let _fbp = getWithExpiry("_fbp");
        if (!_fbp) return "";
        return _fbp;
      }
    },

    watch: {
      inputs: {
        deep: true,
        handler(newValue, oldvalue) {
        },
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>